// import Report from './Report';

export default {
  // component: Report,
  permissions: ['FeedingConsoleMenu/FeedingConsoleReport/'],
  name: app.translate('routes.home.evaluation-360.Report'),
  icon: 'file-chart',
  drawer: true,
};
